/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class TestService extends HttpHandlerService {

        constructor($http: ng.IHttpService, private $q: ng.IQService) {
            super($http);
        }

        public getActiveProcessTypes(): ng.IPromise<any> {
            this.handlerUrl = './api/developer/ActiveProcessTypes';
            return this.useGetHandler({});
        }

        public testAjaxPostException(): ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/AjaxException';
            return this.usePostHandler({});
        };

        public unloadAppPool() : ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/UnloadApplicationPool';
            return this.usePostHandler({});
        }

        public clearReportData(processTypeId: string): ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/ClearReportData';
            return this.usePostHandler({ processTypeId: processTypeId });
        }

        public clearAndRegenReportData(processId: string): ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/ClearAndRegenReportDataForProcess/' + processId;
            return this.usePostHandler({});
        }

        public regenReportData(processTypeId: string): ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/RegenReportData';
            return this.usePostHandler({ processTypeId: processTypeId });
        }

        public clearProcessExecutionData(vm: any): ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/ClearProcessExecutionData';
            return this.usePostHandler(vm);
        }

        public clearProcessCache(): ng.IPromise<boolean> {
            this.handlerUrl = './api/developer/ClearProcessCache';
            return this.usePostHandler({});
        }

        public getProcessInfo(): ng.IPromise<string> {
            this.handlerUrl = './api/developer/GetProcessInfo';
            return this.useGetHandler({});
        }

        public getProcessJson(processId: string): ng.IPromise<any> {
            this.handlerUrl = './api/developer/ProcessJson/' + processId;
            return this.useGetHandler({});
        }
        
        public getCurrentProcessEventMaxId(processId: string): ng.IPromise<number> {
            this.handlerUrl = './api/developer/GetCurrentProcessEventMaxId/' + processId;
            return this.useGetHandler({});
        }

        public rollbackProcess(processId: string, processEventId: number) {
            this.handlerUrl = './api/developer/RollbackProcess/' + processId + "/" + processEventId;
            return this.usePostHandler({});
        }

        public testMemoryFootprint(dto: Wars.Domain.Model.Dtos.TestMemoryConsumptionDto): ng.IPromise<string> {
            this.handlerUrl = './api/developer/MemoryFootprint';
            return this.usePostHandler(dto);
        }

        public clearTestItemsFromMemory(): ng.IPromise<string> {
            this.handlerUrl = './api/developer/ClearTestMemory';
            return this.usePostHandler({});
        }

        public getInWorkProcessConfigs(): ng.IPromise<any> {
            this.handlerUrl = './api/developer/GetInWorkProcessConfigs';
            return this.useGetHandler({});
        }

        public batchVersionAndActivate(model: any): ng.IPromise<any> {
            this.handlerUrl = './api/developer/BatchVersionAndActivate';
            return this.usePostHandler(model);
        }

        public impersonate(userId: string): ng.IPromise<boolean> {
            this.handlerUrl = "./api/test/Impersonate/" + userId;
            return this.usePostHandler({});
        }

        public endImpersonation(): ng.IPromise<boolean> {
            this.handlerUrl = "./api/test/EndImpersonation";
            return this.usePostHandler({});
        }

        public changeDateTime(dto: Wars.Domain.Model.Dtos.DateTimeOffsetDto): ng.IPromise<boolean> {
            this.handlerUrl = "./api/test/ProvideOffset";
            return this.usePostHandler(dto);
        }

        public endChangeDateTime(): ng.IPromise<boolean> {
            this.handlerUrl = "./api/test/ClearOffset";
            return this.usePostHandler({});
        }
    }
}

warsApp.registerService('TestService', ['$http', '$q']);